import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/categorieen",
    name: "categories.index",
    component: () => import("@/modules/categories/views/IndexView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
